module.exports = __webpack_public_path__ + "img/vnpt_qrcode_android_bachnghe.7a32aad5.png";